import { timeslotToLocaleTimeString } from "@/lib/time"

import type { BookingSummaryProps } from "@/components/Booking/BookingSummary"
import { SummaryBlock } from "@/components/Booking/SummaryBlock"

import { TimeIcon } from "@/constants/icons"

type TimeslotProps = {
  timeslot: Date
  style: BookingSummaryProps[`style`]
}

export const Timeslot = ({ timeslot, style }: TimeslotProps) => {
  return (
    <SummaryBlock style={style} title={`Time`} icon={TimeIcon}>
      <p>{timeslotToLocaleTimeString(timeslot)}</p>
    </SummaryBlock>
  )
}
